import { useState } from "react";
import LeadQuiz from "./LeadQuiz";

const plans = [
  {
    id: "start",
    name: "ONYXGASTRO+ Start",
    price: "690",
    setup: "3 900",
    annual: "6 900",
    badge: "QR MENU",
    featured: false,
    description: "Pro menší provozy, které chtějí moderní menu, vlastní branding a měřitelný start.",
    features: ["QR menu", "Mobilní katalog", "Vícejazyčnost", "QR podle stolů / zón", "Základní analytics"]
  },
  {
    id: "pro",
    name: "ONYXGASTRO+ Pro",
    price: "1 490",
    setup: "7 900",
    annual: "14 900",
    badge: "DOPORUČUJEME",
    featured: true,
    description: "Kompletní systém pro objednávky, rezervace a práci s hosty.",
    features: ["Vše ze Start", "Objednávky ke stolu", "Rezervace", "Upsell & cross-sell", "CRM hostů", "Review automation", "ONYX Pay integrace"]
  },
  {
    id: "autopilot",
    name: "ONYXGASTRO+ Autopilot",
    price: "2 990",
    setup: "14 900",
    annual: "29 900",
    badge: "AI + GROWTH",
    featured: false,
    description: "Pro provozy, které chtějí méně ruční práce a více automatizovaného růstu.",
    features: ["Vše z Pro", "AI doporučení", "ONYXA social content", "Automatické follow-upy", "Revenue intelligence", "Segmentace hostů", "Chytré nabídky"]
  }
] as const;

const modules = [
  ["WEB", "ONYXWEB součást balíčku", "Responzivní web s jasnou cestou k rezervaci či poptávce."],
  ["QR", "QR Menu", "Přehledné mobilní menu, varianty, fotografie, alergeny a doporučení."],
  ["↗", "Objednávky ke stolu", "Host objedná z telefonu. Personál dostane jasnou objednávku bez zbytečného čekání."],
  ["◷", "Rezervace", "Rezervační flow, připomínky, provozní pravidla a návaznost na CRM."],
  ["◎", "CRM hostů", "Historie návštěv, preference, segmentace a návratové kampaně."],
  ["★", "Recenze", "Chytrý follow-up po návštěvě a práce s reputací provozu."],
  ["₿", "ONYX Pay", "Platby a monetizace jako samostatná vrstva bez zamknutí do jednoho poskytovatele."],
  ["◈", "ONYXA", "Sociální obsah a růst propojený s nabídkou, akcemi a skutečnými výsledky."],
  ["AI", "Revenue Intelligence", "Sleduje scan → položka → objednávka → tržba a ukazuje, kde vzniká nebo mizí příjem."]
] as const;

function GastroBrand() {
  return <a className="gastro-brand" href="/gastro" aria-label="ONYXGASTRO+ úvod">
    <strong>ONYX<span>GASTRO<em>+</em></span></strong>
    <small>Engineered by OPTIMATEO</small>
  </a>;
}

export default function GastroPage() {
  const [selectedPlan, setSelectedPlan] = useState("ONYXGASTRO+ Pro");
  return (
    <div className="gastro-page" id="top">
      <header className="gastro-topbar">
        <div className="shell gastro-topbar-inner">
          <GastroBrand />
          <nav aria-label="Navigace ONYXGASTRO+">
            <a href="#system">Systém</a>
            <a href="#how">Jak funguje</a>
            <a href="#pricing">Ceník</a>
            <a href="#contact">Kontakt</a>
          </nav>
          <a className="gastro-button gastro-button-small" href="#contact">Získat nabídku →</a>
        </div>
      </header>

      <main>
        <section className="gastro-hero" aria-labelledby="gastro-hero-title" onPointerMove={(event) => {
          if (event.pointerType !== "mouse") return;
          const rect = event.currentTarget.getBoundingClientRect();
          event.currentTarget.style.setProperty("--pointer-x", `${event.clientX - rect.left}px`);
          event.currentTarget.style.setProperty("--pointer-y", `${event.clientY - rect.top}px`);
        }}>
          <div className="gastro-hero-ambient" aria-hidden="true" />
          <div className="shell gastro-hero-grid">
            <div className="gastro-hero-copy">
              <p className="gastro-kicker">ONYXGASTRO+ / CHYTŘEJŠÍ GASTRO PROVOZ</p>
              <h1 id="gastro-hero-title">Vy se starejte o hosty. <span>O zbytek provozu se postaráme my.</span></h1>
              <h2>Vlastní web ONYXWEB, QR menu, objednávky, rezervace a péče o hosty v jednom modulárním řešení. Začněte tím, co váš podnik potřebuje nejvíc.</h2>
              <div className="gastro-hero-actions">
                <a className="gastro-button" href="#contact">Získat nabídku pro podnik ↗</a>
                <a className="gastro-button ghost" href="#how">Jak to funguje ↓</a>
              </div>
              <div className="gastro-hero-proof"><span>✓ ONYXWEB součást řešení</span><span>✓ Moduly podle provozu</span><span>✓ Mobile-first</span></div>
            </div>
            <div className="gastro-hero-visual" aria-label="Ilustrační návrh rozhraní ONYXGASTRO+">
              <div className="gastro-photo"><img src="/template-previews/food.webp" alt="Inspirativní gastro design" /></div>
              <div className="gastro-system-card">
                <div className="gastro-system-head"><small>ONYXGASTRO+ / PŘEHLED PROVOZU</small><span>VIZUALIZACE</span></div>
                <div className="gastro-ui-top"><strong>Vše na jednom místě.</strong><small>Koncept pracovního přehledu</small></div>
                <div className="gastro-flow">
                  <div><i>01</i><b>QR menu</b><small>Nabídka</small></div>
                  <span>→</span><div><i>02</i><b>Objednávky</b><small>Od hostů</small></div>
                  <span>→</span><div><i>03</i><b>Rezervace</b><small>Plán stolů</small></div>
                </div>
                <div className="gastro-metrics">
                  <article><span>WEB</span><strong>ONYXWEB</strong></article>
                  <article><span>HOSTÉ</span><strong>CRM</strong></article>
                  <article><span>PŘEHLED</span><strong>Reporting</strong></article>
                </div>
                <div className="gastro-system-foot">Ilustrační UI • nikoli živá provozní data</div>
              </div>
              <div className="gastro-phone" aria-hidden="true"><div className="gastro-phone-notch"/><span>VAŠE MENU</span><strong>Co si dnes dáte?</strong><div className="gastro-phone-photo"/><p>Prohlédnout nabídku</p><b>Otevřít menu ↗</b></div>
            </div>
          </div>
        </section>

        <section className="shell gastro-section" id="system">
          <div className="gastro-section-heading">
            <p>PRO KAŽDÝ PODNIK TO PODSTATNÉ</p>
            <h2>Méně administrativy. Více času na hosty.</h2>
            <span>Modulární řešení, které můžeme rozšiřovat podle potřeb podniku.</span>
          </div>
          <div className="gastro-module-grid">
            {modules.map(([icon, title, copy]) => (
              <article key={title}>
                <span>{icon}</span>
                <h3>{title}</h3>
                <p>{copy}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="gastro-how" id="how">
          <div className="shell"><div className="gastro-section-heading center"><p>JAK TO FUNGUJE</p><h2>Od QR menu k lepšímu servisu.</h2><span>Čtyři propojené kroky, které přizpůsobíme vašemu provozu.</span></div>
            <div className="gastro-how-grid">
              <article><i>01</i><strong>Host naskenuje QR</strong><p>Na telefonu se otevře vaše nabídka.</p></article>
              <article><i>02</i><strong>Vybere si</strong><p>Prohlíží menu, varianty a doporučení.</p></article>
              <article><i>03</i><strong>Objedná nebo rezervuje</strong><p>Po zapnutí modulu odešle požadavek provozu.</p></article>
              <article><i>04</i><strong>Vy máte přehled</strong><p>Spravujete hosty, nabídku a další komunikaci.</p></article>
            </div>
          </div>
        </section>

        <section className="gastro-showcase" id="showcase">
          <div className="shell gastro-showcase-grid">
            <div className="gastro-showcase-copy">
              <p>REFERENČNÍ PILOT</p>
              <h2>Buddha Čajovna jako referenční pilot.</h2>
              <p>
                Připravovaná širší integrace propojuje web, QR menu, objednávky, rezervace,
                cateringové poptávky, CRM, marketing a analytics do jednoho provozního systému.
              </p>
              <div className="gastro-showcase-tags">
                <span>QR Menu</span><span>Table Orders</span><span>Reservations</span><span>Catering</span><span>CRM</span><span>Analytics</span>
              </div>
              <a href="https://www.buddhacajovna.cz" target="_blank" rel="noreferrer">Otevřít Buddha Čajovnu ↗</a>
            </div>
            <figure className="gastro-showcase-visual">
              <img src="/project-previews/buddha.webp" alt="Buddha Čajovna — referenční gastro projekt" />
              <figcaption>
                <b>BUDDHA ČAJOVNA</b>
                <span>Praha · pilotní integrace, vybrané moduly v ověřování</span>
              </figcaption>
            </figure>
          </div>
        </section>

        <section className="shell gastro-section" id="pricing">
          <div className="gastro-section-heading center">
            <p>ORIENTAČNÍ BALÍČKY</p>
            <h2>Začněte menu. Přidejte provoz. Automatizujte růst.</h2>
            <span>Cenu a dostupnost modulů upřesníme v nabídce. Platební poplatky nejsou zahrnuty.</span>
          </div>

          <div className="gastro-pricing-grid">
            {plans.map((plan) => (
              <article key={plan.id} className={plan.featured ? "featured" : ""}>
                <div className="gastro-plan-badge">{plan.badge}</div>
                <h3>{plan.name}</h3>
                <p>{plan.description}</p>
                <div className="gastro-price">
                  <strong>{plan.price}</strong>
                  <span>Kč / měsíc</span>
                </div>
                <small>orientačně {plan.annual} Kč / rok · zřízení od {plan.setup} Kč</small>
                <ul>
                  {plan.features.map((feature) => <li key={feature}>✓ {feature}</li>)}
                </ul>
                <a
                  className="gastro-button"
                  href="#contact"
                  onClick={() => setSelectedPlan(plan.name)}
                >
                  Poptat {plan.name.replace("ONYXGASTRO+ ", "")} →
                </a>
              </article>
            ))}
          </div>

          <div className="gastro-founding">
            <div>
              <span>FOUNDING PARTNER</span>
              <strong>Individuální podmínky pro pilotní partnery</strong>
              <p>Konkrétní podmínky a dostupnost pilotní spolupráce ověříme v poptávce.</p>
            </div>
            <a href="#contact" onClick={() => setSelectedPlan("Founding Partner")}>Mám zájem →</a>
          </div>
        </section>

        <section className="gastro-contact" id="contact">
          <div className="shell gastro-contact-grid">
            <div>
              <p>SPUSŤTE PRVNÍ VERZI</p>
              <h2>Ukažte nám provoz. Navrhneme ideální konfiguraci.</h2>
              <span>Bez závazku. Začneme tím, co přinese nejrychlejší provozní nebo obchodní efekt.</span>
            </div>
            <LeadQuiz key={selectedPlan} service="gastro" source="onyxweb.cz/gastro" heading="Najdeme vhodné řešení pro váš podnik"
              initialChoice={selectedPlan}
              options={[
                { value: "ONYXGASTRO+ Start", label: "Web ONYXWEB a QR menu" },
                { value: "ONYXGASTRO+ Pro", label: "Objednávky, rezervace a CRM" },
                { value: "ONYXGASTRO+ Autopilot", label: "Automatizace provozu" },
                { value: "Founding Partner", label: "Pilotní spolupráce" }
              ]} projectPlaceholder="název provozu nebo web" />
          </div>
        </section>
      </main>

      <footer className="gastro-footer">
        <div className="shell">
          <GastroBrand />
          <span>Web ONYXWEB · QR Menu · Rezervace · CRM</span>
          <span>Provozovatel: Petr Matěj · IČO 02558220 · <b>OPTIMATEO</b></span>
        </div>
      </footer>
    </div>
  );
}
